import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import { LocationFragmentFragmentDoc } from './LocationsFragments.generatedTypes'
export type CdrAnalysisLocationTripPoint_FragmentFragment = {
  __typename: 'CDRAnalysisLocationTripPoint'
  maxTime: string
  minTime: string
  location: {
    __typename: 'Location'
    locationId: string
    name?: string | null
    address?: string | null
    latitude: number
    longitude: number
  }
}

export const CdrAnalysisLocationTripPoint_FragmentFragmentDoc = gql`
  fragment CdrAnalysisLocationTripPoint_Fragment on CDRAnalysisLocationTripPoint {
    location {
      ...LocationFragment
    }
    maxTime
    minTime
  }
  ${LocationFragmentFragmentDoc}
`
